import { Grid, Tooltip, Typography } from '@optimus-web/core';

interface LabelValueProps {
    label: string | React.ReactElement;
    value: string | React.ReactElement | undefined;
}

// We will propose this component to the Design System team.
export const LabelValue = ({ label, value }: LabelValueProps) => (
    <Grid templateColumns="max-content minmax(0, 1fr)" columnGap="100" style={{ width: '100%' }}>
        <Typography textStyle="bodyLarge" variant="tertiary" as="div">
            {label}
        </Typography>
        <TooltipWrapper as="div" tooltip={value} textStyle="bodyLarge" variant="primary" ellipsis>
            {value}
        </TooltipWrapper>
    </Grid>
);

const TooltipWrapper = Tooltip(Typography);
